import adjustButtonStyle from "./adjustButtonStyle.js";
import { expandIcon } from './resources/Icons.js';
const av = Autodesk.Viewing;
const avu = av.UI;

const GlobalManagerMixin = av.GlobalManagerMixin;

export default class MinimapExpandButton {
    constructor(parent) {
        this.parent = parent;
        this.parentElement = parent.mapWidgetHeader;
        this.viewer = parent.viewer;
        this.setGlobalManager(parent.viewer.globalManager);

        this.expandButton = new avu.Button("Minimap_Expand");
        this.expandButton.setGlobalManager(this.globalManager);
        this.expandButton.onClick = () =>
            parent.minimap3DExtension.expandSheetMap();
        this.expandButton.icon.innerHTML = expandIcon;
        this.expandButton.icon.style.width = "20px";
        this.expandButton.icon.style.height = "20px";
        this.parentElement.appendChild(this.expandButton.container);

        adjustButtonStyle(this.expandButton, false);

        // Set icons and tooltips
        this.update();
    }

    update() {
        this.expandButton.setState(
            this.parent.minimap3DExtension.isSheetVisible()
                ? avu.Button.State.INACTIVE
                : avu.Button.State.DISABLED
        );

        // Set tooltips based on current states
        const Expand = Autodesk.Viewing.i18n.translate("Go to 2D");
        this.expandButton.setToolTip(Expand);
    }

    dtor() {
      this.viewer = null;
    }
}

GlobalManagerMixin.call(MinimapExpandButton.prototype);
